import {Component, EventEmitter, inject, Output, ViewChild, viewChild} from '@angular/core';

import {FormControl} from '@angular/forms';

import {
  EretailDynamicFormComponent,
} from '../../../../shared/components/eretail-dynamic-form/eretail-dynamic-form.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { relatoriosAgendadosColumns } from '../../appointments/appointments.component';
import { ButtonComponent } from '../../../../shared/components/button/eretail-button/button.component';
import { EretailModalComponent } from "../../../../shared/components/modal/eretail-modal/eretail-modal.component";
import { EretailContentWrapperHeaderComponent, headerField } from '../../../../shared/components/eretail-content-wrapper/eretail-content-wrapper-header/eretail-content-wrapper-header.component';
import { IEretailForm } from 'src/app/shared/interfaces/form';
import { ReportsService } from 'src/app/core/services/reports.service';
import { ToastService } from 'src/app/core/helpers/toast.service';

@Component({
  selector: 'app-schedule-report-card-modal',
  standalone: true,
  imports: [EretailModalComponent, EretailContentWrapperHeaderComponent, EretailDynamicFormComponent, ButtonComponent],
  templateUrl: './schedule-report-card-modal.component.html',
  styleUrl: './schedule-report-card-modal.component.scss',
})
export class ScheduleReportCardModalComponent {
  protected data = inject(MAT_DIALOG_DATA);
  readonly reportsService = inject(ReportsService);
  readonly _toast = inject(ToastService);
  dialogRef = inject(MatDialogRef<ScheduleReportCardModalComponent>);

  @ViewChild('form') form!: EretailDynamicFormComponent;

  protected control = new FormControl('');
  protected newReportForm: IEretailForm = {
    id: 1,
    type: 'non-noded',
    formTitle: '',
    formSubTitle: '',
    fields: [
      {
        elId: 'tipo-relatorio',
        displayName: 'Tipo do relatório',
        placeholder: 'Selecione o Relatório',
        fieldType: 'select',
        fill: true,
        nodeName: 'tipoRelatorio',
        value: this.control,
        options: [
          {id: 1, value: 'Mapa de vendas'},
          {id: 2, value: 'Ruptura'},
        ],
        lineOrder: 0,
        validators: [{type: 'required', message: 'Campo Obrigatório.'}],
      },
      {
        elId: 'data-envio',
        displayName: 'Dia de Envio',
        placeholder: 'Selecione o Dia',
        options: [
          {id: 1, value: 1},
          {id: 2, value: 2},
          {id: 3, value: 3},
          {id: 4, value: 4},
          {id: 5, value: 5},
          {id: 6, value: 6},
          {id: 7, value: 7},
          {id: 8, value: 8},
          {id: 9, value: 9},
          {id: 10, value: 10},
          {id: 11, value: 11},
          {id: 12, value: 12},
          {id: 13, value: 13},
          {id: 14, value: 14},
          {id: 15, value: 15},
          {id: 16, value: 16},
          {id: 17, value: 17},
          {id: 18, value: 18},
          {id: 19, value: 19},
          {id: 20, value: 20},
          {id: 21, value: 21},
          {id: 22, value: 22},
          {id: 23, value: 23},
          {id: 24, value: 24},
          {id: 25, value: 25},
          {id: 26, value: 26},
          {id: 27, value: 27},
          {id: 28, value: 28},
          {id: 29, value: 29},
          {id: 30, value: 30},
          {id: 31, value: 31},
        ],
        fieldType: 'select',
        fill: true,
        nodeName: 'diaEnvio',
        value: this.control,
        lineOrder: 1,
        validators: [{type: 'required', message: 'Campo Obrigatório.'}],
      },
      {
        elId: 'periodo',
        displayName: 'Período',
        placeholder: 'Selecione o Período',
        fieldType: 'select',
        fill: true,
        options: [
          {
            value: 'Último 1 Dia',
            id: 1,
          },
          {
            value: 'Últimos 7 Dias',
            id: 7,
          },
          {
            value: 'Últimos 14 Dias',
            id: 14,
          },
          {
            value: 'Últimos 21 Dias',
            id: 21,
          },
          {
            value: '1 Mês',
            id: 30,
          },
        ],
        nodeName: 'periodo',
        value: this.control,
        lineOrder: 1,
        validators: [{type: 'required', message: 'Campo Obrigatório.'}],
      },
    ],
    lines: [
      {
        order: 0,
      },
      {
        order: 1,
      },
    ],
    sections: [],
  };

  isLoading = false;

  // Header Variables
  protected headerFields: headerField[] = [
    {
      formControl: this.control,
      placeholder: 'Pesquisar',
      icon: 'search',
      fieldClass: 'w-75 me-5',
      id: 'pesquisar',
    },

    {
      formControl: this.control,
      placeholder: 'Filtrar:',
      fieldClass: 'w-50',
      inputType: 'select',
      id: 'filtrar',
    },
  ];

  // Table Variables
  protected currentPage = 1;
  protected pageSize = 20;
  protected dataSource: Array<any> = [];

  ngOnInit(): void {}

  onSubmit(): void {
    this.isLoading = true;
    const form = this.form.dynamicForm;

    if (form.invalid) {
      return;
    }

    this.reportsService
      .schedule({
        ...this.form.dynamicForm.getRawValue(),
        ativo: true,
      })
      .subscribe({
        next: (res) => {
          this._toast.showSuccessToast('Relatório Agendado com Sucesso!', '');
          this.isLoading = false;
          this.dialogRef.close(res);
        },
        error: () => {
          this._toast.showErrorToast('Falha ao Agendar relatório.', '');
          this.isLoading = false;
        },
      });
  }
}
